@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --font-heading: 'Inter', system-ui, sans-serif;
  --font-body: 'Inter', system-ui, sans-serif;
  --font-label: 'Inter', system-ui, sans-serif;

  --background-50: 0.98 0.005 250;
  --background-100: 0.95 0.01 250;
  --background-200: 0.92 0.01 250;
  --background-300: 0.88 0.015 250;
  --background-400: 0.82 0.02 250;
  --background-500: 0.75 0.02 250;
  --background-600: 0.65 0.02 250;
  --background-700: 0.55 0.02 250;
  --background-800: 0.45 0.02 250;
  --background-900: 0.35 0.02 250;
  --background-950: 0.25 0.02 250;

  --primary-50: 0.95 0.03 245;
  --primary-100: 0.90 0.04 245;
  --primary-200: 0.85 0.05 245;
  --primary-300: 0.75 0.06 245;
  --primary-400: 0.60 0.07 245;
  --primary-500: 0.45 0.08 245;
  --primary-600: 0.38 0.07 245;
  --primary-700: 0.30 0.06 245;
  --primary-800: 0.22 0.05 245;
  --primary-900: 0.15 0.04 245;
  --primary-950: 0.10 0.03 245;

  --accent-50: 0.97 0.02 250;
  --accent-100: 0.93 0.04 250;
  --accent-200: 0.88 0.06 250;
  --accent-300: 0.78 0.08 250;
  --accent-400: 0.68 0.10 250;
  --accent-500: 0.55 0.12 250;
  --accent-600: 0.48 0.11 250;
  --accent-700: 0.40 0.10 250;
  --accent-800: 0.32 0.09 250;
  --accent-900: 0.24 0.08 250;
  --accent-950: 0.16 0.07 250;

  --secondary-50: 0.96 0.01 260;
  --secondary-100: 0.92 0.02 260;
  --secondary-200: 0.86 0.03 260;
  --secondary-300: 0.78 0.04 260;
  --secondary-400: 0.70 0.05 260;
  --secondary-500: 0.60 0.06 260;
  --secondary-600: 0.52 0.05 260;
  --secondary-700: 0.44 0.05 260;
  --secondary-800: 0.36 0.04 260;
  --secondary-900: 0.28 0.04 260;
  --secondary-950: 0.20 0.03 260;

  --foreground-50: 0.97 0.01 250;
  --foreground-100: 0.94 0.01 250;
  --foreground-200: 0.88 0.02 250;
  --foreground-300: 0.78 0.03 250;
  --foreground-400: 0.68 0.04 250;
  --foreground-500: 0.58 0.04 250;
  --foreground-600: 0.48 0.04 250;
  --foreground-700: 0.38 0.04 250;
  --foreground-800: 0.28 0.04 250;
  --foreground-900: 0.18 0.04 250;
  --foreground-950: 0.10 0.03 250;
}

@layer base {
  html {
    font-family: var(--font-body);
    scroll-behavior: smooth;
  }
  body {
    background-color: oklch(var(--background-50));
    color: oklch(var(--foreground-950));
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-heading);
    font-weight: 700;
    letter-spacing: -0.02em;
  }
}

@layer components {
  .container-page {
    @apply w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8;
  }
  .section-padding {
    @apply py-16 md:py-20 lg:py-24;
  }
  .section-padding-sm {
    @apply py-12 md:py-16;
  }
  .btn-primary {
    @apply inline-flex items-center justify-center px-6 py-3 rounded-md font-semibold text-sm tracking-wide transition-all duration-200 bg-primary-500 text-background-50 hover:bg-primary-600 whitespace-nowrap;
  }
  .btn-secondary {
    @apply inline-flex items-center justify-center px-6 py-3 rounded-md font-semibold text-sm tracking-wide transition-all duration-200 border-2 border-primary-500 text-primary-700 hover:bg-primary-50 whitespace-nowrap;
  }
  .card-base {
    @apply rounded-lg bg-white border border-background-200/80 transition-all duration-300;
  }
  .card-hover {
    @apply hover:border-background-300 hover:shadow-sm;
  }
}

.honeypot-field {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

/* Visually hidden link that appears on keyboard focus */
.skip-link {
  position: absolute;
  left: -9999px;
  top: 0;
  z-index: 100;
  background-color: oklch(var(--primary-500));
  color: oklch(var(--background-50));
  padding: 0.75rem 1.5rem;
  border-radius: 0 0 0.5rem 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
}
.skip-link:focus {
  left: 1rem;
}

/* Visible keyboard-focus indicator */
:focus-visible {
  outline: 2px solid oklch(var(--accent-500));
  outline-offset: 2px;
}

/* Respect reduced-motion preferences */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
  html {
    scroll-behavior: auto;
  }
}